module.exports = __webpack_public_path__ + "media/images/landing/banner_logo_01.en-993c2dfcfbbe25e748fe9a97086a3b2e.png";